import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Helmet } from "react-helmet";
import PortfolioListDisplay from './PortfolioListDisplay';

class PortfolioWrap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      props : this.props,
      navigate : this.props.navigate,
      symbol: this.props.symbol
    };
    console.log('PortfolioWrap ', this.state.symbol);
  }

  componentDidMount() {
  }

  render() {
    return (
      <div>
        <Helmet>
          <title>Traders/Investors Portfolio</title>
          <meta charSet="utf-8" />
          <link rel="canonical" href="https://www.vizfm.com/portfolio" />
          <meta name="description" content="Investors and Traders portfolio where they can track and monitor their stocks or ETF" />
        </Helmet>
        <Container fluid className="p-2">
          <Row>
            <Col><h5>Traders/Investors Portfolio</h5></Col>
          </Row>
          <Row>
            <Col><PortfolioListDisplay symbol={this.state.symbol}/></Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default PortfolioWrap;
